import { render } from "./ClientDetails.vue?vue&type=template&id=2015f4fc&scoped=true"
import script from "./ClientDetails.vue?vue&type=script&lang=js"
export * from "./ClientDetails.vue?vue&type=script&lang=js"

import "./ClientDetails.vue?vue&type=style&index=0&id=2015f4fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2015f4fc"]])

export default __exports__